import Modal from "react-modal";
import { useState } from "react";
import { SearchIcon } from "../PurchaseHistory/purchaseHistory.index";
import { usePurchaseRecommendationViewModel } from "../../../viewModel/usePurchaseManagementViewModel";
import { LoadingContent } from "../../../components/SharedComponents/sharedComponents.index";
import { LOADING_CONTENT_TYPE } from "../../../components/SharedComponents/LoadingContent/loading.content.constants";

export const AddItemModal = ({ actions, ctx, uiState }) => {
  
  const { onSearchChange, onClose, addItensToOrder } = actions || {};
  const { 
    searchQuery,
    supplierId,
    orderItemsToUse
  } = ctx || {};
  const { isOpen } = uiState || {};

  const [isInputFocused, setIsInputFocused] = useState(false);

  const vm = usePurchaseRecommendationViewModel({
    shouldFetchPurchaseRecommendationData: false,
    shouldFetchOrdersData: false,
    shouldFetchAvailableItens: true
  }, { supplierId: supplierId })

  const availableItems = vm?.ctx?.availableItens?.availableItensFetched || [];

  if (vm?.uiState?.availableItens?.isLoadingFetchAvailableItens) {
    return <LoadingContent label={"Consultando produtos disponíveis..."} type={LOADING_CONTENT_TYPE.LOCAL_PAGE_STATE} mode={LOADING_CONTENT_TYPE.LOCAL_PAGE_STATE}/>
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "2rem",
          borderRadius: "8px",
          width: "700px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
        },
      }}
      contentLabel="Adicionar item"
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
        <hgroup>
          <h2 style={{ margin: 0, fontSize: "1.2rem", fontFamily: "Lato, sans-serif" }}>
              <strong>Selecionar produto </strong>
          </h2>

          <p style={{ color: 'rgb(100, 116, 139', fontSize: '0.875rem' }}>Busque e selecione o produto que deseja adicionr ao pedido</p>        
        </hgroup>

        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#626772",
          }}
        >
          ✕
        </button>
      </div>

      {/* Filtro de busca */}
      <div style={{ position: "relative", width: "100%" }}>
        <div style={{
          position: "absolute",
          left: "0.75rem",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          alignItems: "center",
          pointerEvents: "none",
        }}>
          <SearchIcon />
        </div>
      <input
          type="text"
          placeholder="Buscar produto..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
          style={{
          backgroundColor: 'transparent',
          border: `1px solid ${isInputFocused ? "#FF6600" : "hsl(214.3 31.8% 91.4%)"}`,
          borderRadius: "6px",
          boxSizing: 'border-box',
          color: "#626772",
          fontSize: "0.875rem",
          inlineSize: "100%",
          lineHeight: '1.25rem',
          padding: "0.5rem 1rem 0.5rem 3.25rem",
          outline: "none",
          }}
      />
      </div>

      {/* Espaço para tabela */}
      {(() => {
        const filteredItems = availableItems
          .filter(item => !orderItemsToUse.some(orderItem => orderItem.productId === item.productId))
          .filter(item => {
            if (!searchQuery) return true;
            return item.productName.toLowerCase().includes(searchQuery.toLowerCase());
          });

        if (filteredItems.length === 0 && availableItems.length > 0) {
          return (
            <p style={{ textAlign: 'center', color: '#888780', fontSize: '0.875rem' }}>
              O único produto disponível deste fornecedor já consta neste pedido.
            </p>
          );
        }

        return filteredItems.map((item) => (
          <ProductCard
            key={item.productId}
            actions={{
              onClick: () => addItensToOrder({ itemToAdd: item })
            }}
            ctx={{
              productName: item.productName,
              sku: item.sku,
              subgroup: item.productSubgroupName,
            }}
          />
        ));
        // return filteredItems.map((item) => (
        //   <ProductCard
        //     key={item.productId}
        //     actions={{
        //       onClick: () => addItensToOrder({ itemToAdd: item, currentOrderState: orderItemsToUse })
        //     }}
        //     ctx={{
        //       productName: item.productName,
        //       sku: item.sku,
        //       subgroup: item.productSubgroupName,
        //     }}
        //   />
        // ));
      })()}
    </Modal>
  );
};

function ProductCard({ ctx, actions }) {
  const { productName, sku, subgroup } = ctx;
  const { onClick } = actions || {};

  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "12px 16px",
        borderBottom: "1px solid #f0f2f4",
        cursor: onClick ? "pointer" : "default",
        backgroundColor: "#fff",
      }}
    >
      <ProductCard.BoxIcon />

      <div style={{ flex: 1 }}>
        <p style={{
          margin: 0,
          fontSize: "14px",
          fontWeight: "700",
          fontFamily: "Lato, sans-serif",
          color: "#2c2c2a",
        }}>
          {productName}
        </p>
        <p style={{
          margin: 0,
          fontSize: "12px",
          fontFamily: "Lato, sans-serif",
          color: "#888780",
        }}>
          SKU {sku} · {subgroup}
        </p>
      </div>

      <ProductCard.ChevronIcon />
    </div>
  );
};

ProductCard.BoxIcon = function BoxIcon() {
  return (
    <div style={{
      width: "36px",
      height: "36px",
      borderRadius: "8px",
      backgroundColor: "#FFF5EC",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
          stroke="#e75d0d"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"
          stroke="#e75d0d"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

ProductCard.ChevronIcon = function ChevronIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 18l6-6-6-6"
        stroke="#e75d0d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};